<template>
  <Layout :style="styles" :is-loading="isLoading" :background-url="backgroundImage.url">
    <template #title>
      <Header v-if="title" class="p-2" :title="title" />
    </template>
    <template #switcher>
      <slot name="switcher"></slot>
    </template>
    <template #prices>
      <Shimmer
        v-for="(
          {
            cost,
            upgrade,
            currencySymbol,
            isAnnually,
            isMonthlyAnnualCommitment,
            name,
            specs,
            hasFreeTrial
          },
          index
        ) in prices"
        :key="index"
        :is-loading="isLoading"
        :is-highlighted="isHighlighted(index)"
      >
        <PriceVertical
          v-if="!isLoading"
          :price="cost"
          :period="period"
          :title="name"
          :button-text="getFreeTrialButtonText(hasFreeTrial, buttonTextFreeTrial, buttonText)"
          :see-more="seeMore"
          :see-less="seeLess"
          :price-description="priceDescriptionText(isMonthlyAnnualCommitment, priceDescription)"
          :price-description-alt="priceDescriptionAlt"
          :specs="specs"
          :currency-symbol="currencySymbol"
          :is-button-enabled="upgrade"
          :is-annually="isAnnually"
          :is-monthly-annual-commitment="isMonthlyAnnualCommitment"
          :highlighted="isHighlighted(index)"
          @subscribe="$emit('subscribe', { price: prices[index] })"
        />
      </Shimmer>
    </template>
  </Layout>
</template>
<script>
import { mapGetters } from 'vuex';
import PriceVertical from '@/components/Prices/PriceVertical';
import Shimmer from '@/components/Prices/PriceAtoms/Shimmer';
import Header from '@/components/Prices/PriceAtoms/Header';
import Layout from '@/components/Prices/Layouts/PricesVertical/index.vue';

export default {
  components: { PriceVertical, Shimmer, Header, Layout },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    title: {
      type: Array,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    primaryColor: {
      type: String,
      required: true
    },
    secondaryColor: {
      type: String,
      required: true
    },
    terciaryColor: {
      type: String,
      required: true
    },
    backgroundImage: {
      type: Object,
      required: true
    },
    prices: {
      type: Array,
      required: true
    },
    seeMore: {
      type: String,
      required: true
    },
    seeLess: {
      type: String,
      required: true
    },
    period: {
      type: String,
      required: true
    },
    priceDescription: {
      type: String,
      required: true
    },
    priceDescriptionAlt: {
      type: String,
      required: true
    },
    buttonTextFreeTrial: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('plan-areas', ['getFreeTrialButtonText']),
    styles() {
      return `
        --primary-color: ${this.primaryColor};
        --secondary-color: ${this.secondaryColor};
        --terciary-color: ${this.terciaryColor};
      `;
    }
  },
  methods: {
    isHighlighted(index) {
      return Boolean(index === 1);
    },
    priceDescriptionText(isMonthlyAnnualCommitment, priceDescription) {
      return isMonthlyAnnualCommitment
        ? this.$t('plans.common.cards.billedMonthlyAnnualCommitment')
        : priceDescription;
    }
  }
};
</script>
